export default __webpack_public_path__ + "static/media/avatar3.aea913cb.gif";